import { useState, useEffect, useRef } from 'react';

const useScreenResolution = () => {
  const [screenResolution, setScreenResolution] = useState(getScreenResolution());
  const prevResolutionRef = useRef(screenResolution);
  const resizeTimeoutRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      // CRITICAL: Debounce resize events to prevent rapid state changes
      // Clear any pending timeout
      if (resizeTimeoutRef.current) {
        clearTimeout(resizeTimeoutRef.current);
      }

      // Set new timeout to update after resize stops for 150ms
      resizeTimeoutRef.current = setTimeout(() => {
        const update = getScreenResolution();
        const prev = prevResolutionRef.current;

        // Only update if resolution category actually changed
        if(prev.mobile !== update.mobile ||
          prev.tablet !== update.tablet ||
          prev.desktop !== update.desktop) {
          console.log('📐 Screen resolution changed:', prev, '→', update);
          prevResolutionRef.current = update;
          setScreenResolution(update);
        }
      }, 150); // Wait 150ms after resize stops
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      if (resizeTimeoutRef.current) {
        clearTimeout(resizeTimeoutRef.current);
      }
    };
  }, []); // Empty dependency array - only set up listener once

  return screenResolution;
};

const getScreenResolution = () => {
  const width = window.innerWidth;
  return {
    mobile: width < 768,
    tablet: width >= 768 && width <= 1024,
    desktop: width > 1024,
  };
};

export default useScreenResolution;
